// extracted by mini-css-extract-plugin
export var container = "_1p-0";
export var disabled = "_1p-4";
export var fullWidth = "_1p-3";
export var lined = "_1p-1";
export var selected = "_1p-5";
export var tab = "_1p-2";